import * as Yup from 'yup';
import { createPaginationSchema } from '@emfood/shared';

export const DataMapperTemplateListSearchParamsSchema = createPaginationSchema().concat(
  Yup.object({
    distributorOrgId: Yup.string().optional(),
  })
);
